const getError = state => state.error
const getNotification = state => state.notification

export default {
    getError,
    getNotification
}